(function(){
  angular.module('edxComponents').filter('astLevelName', ['localeService', function(localeService) {
    return astLevelNameFilter;

    function astLevelNameFilter(level, disposition) {

      var useYears = localeService.getLocale() === 'en-gb';
      if (disposition === 'short') {
        if (useYears) {
          return String(level.grade + 1);
        }
        return fixedAbbreviation(level.name) ||
          gradeAbbreviation(level.name) ||
          level.name;
      } else {
        if (useYears) {
          return 'YEAR ' + (level.grade + 1);
        }
        return level.name;
      }

      function fixedAbbreviation(name) {
        return {
          'Kindergarten': 'K',
          'Algebra': 'ALG',
          '\u00C1lgebra': '\u00C1LG', // Accented A, not sure why editor inserts wrong character so escape is needed
          'Algebra 1': 'ALG1',
          'Algebra 2': 'ALG2',
          'Algebra I': 'ALGI',
          'Algebra II': 'ALGII',
          'Foundations in Algebra': 'FA',
          'Geometry': 'GEO',
          'High School': 'HS',
          'High School Algebra I': 'ALGI',
          'High School - Algebra': 'ALG',
          'High School - Functions': 'FUN',
          'High School - Geometry': 'GEO',
          'High School - Statistics and Probability': 'S&P',
          'Intermediate Algebra': 'IA',
          'Mathematics I': 'MathI',
          'Probability and Statistics': 'P&S',
          'Pre-Algebra': 'PreA',
          'Pre-Calculus': 'PreC',
          'Trigonometry': 'TRIG',
          'Geometry with Data Analysis': 'GDA',
          'Algebra I with Probability': 'ALGI',
          'Algebra II with Statistics': 'ALGII',
          'Mathematical Modeling': 'MM',
          'Applications of Finite Mathematics': 'AFM',
          'Precalculus': 'PreC',
          'Advanced Topics': 'AT',
          'Statistics and Probability': 'SP',
          'Functions': 'F',
          'Grade 9-10': '9-10',
          'Grade 11-12': '11-12',
          'Algebra, Functions, and Data Analysis': 'AFDAS',
          'Mathematical Analysis': 'MAS'
        }[name];
      }

      function gradeAbbreviation(name) {
        var m = /^Grade (\d+)$/.exec(name);
        if (m && m.length === 2) {
          return m[1];
        } else {
          return undefined;
        }
      }
    }
  }]);
})();
